module.exports = __webpack_public_path__ + "img/three-scenes.868d59c2.png";